import { useTranslation } from "react-i18next";

import { LoginForm } from "@/components/auth/LoginForm";

/** Public landing page: branded splash with the leaf pattern (item 16). */
export function LandingPage() {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen overflow-hidden bg-[oklch(37.76%_0.0745_166.69)] text-white">
      {/* Layered leaf pattern, anchored bottom-left. */}
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-10 -left-16 w-[min(90vw,55rem)] opacity-80"
      >
        <img src="/images/hero-pattern-2.svg" alt="" className="h-auto w-full" />
      </div>

      <header className="relative z-10">
        <div className="mx-auto flex h-25 max-w-6xl items-center px-6 lg:px-10">
          <img src="/images/logo.svg" alt={t("common.appName")} className="h-20 w-auto" />
        </div>
      </header>

      <main className="relative z-10 mx-auto flex min-h-[calc(100vh-5rem)] max-w-6xl items-center px-6 lg:px-10">
        <div className="grid w-full items-center gap-10 lg:grid-cols-2">
          <section className="max-w-xl">
            <h1 className="text-5xl font-bold leading-tight tracking-tight lg:text-6xl">
              {t("landing.heroTitle")}
              <br />
              {t("landing.heroLine2")}
            </h1>
            <div className="mt-8 h-px w-24 bg-white/60" />
            <p className="mt-8 text-xl text-white/85">{t("landing.heroBody")}</p>
          </section>
          <div className="flex justify-center lg:justify-end">
            <LoginForm showBackLink={false} />
          </div>
        </div>
      </main>
    </div>
  );
}
